import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../../common/withRouter';
import {
  DataDefinitionList,
  Loader,
  Notification,
  Message
} from '../../../web.common';
import { LayoutContext } from '../../layout/siteLayout';
import PageTop from '../../layout/PageTop';
import withApi from '../../higherOrderComponents/withApi';
import {
  DisplayBoolean,
  DisplayDate,
  DisplayGuid,
  DisplayStatus,
  DisplayType,
  DisplayPaymentMethod
} from '../../items';
import { DetailsRightBar, NoLink, Divider } from '../DetailsRightBar';
import { paymentMethodStatus } from '../../../enums/paymentMethodStatus';
import { paymentMethodType } from '../../../enums/paymentMethodType';

class CreditCardInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      creditCardData: null
    };
  }

  async componentDidMount() {
    const { match: { params: { creditCardId } } } = this.props;
    const { api: { paymentMethods: { getCreditCard } } } = this.props;

    try {
      const creditCardData = await getCreditCard(creditCardId);
      this.setState({ creditCardData });
    }
    catch (e) {
      this.setState({ errorMessage: new Message('error', 'Unable to get data') });
    }
  }

  render() {
    const { match: { params: { creditCardId } } } = this.props;
    const { creditCardData, errorMessage } = this.state;

    let mappedData = null;

    if (creditCardData) {
      const {
        Id,
        CreatedAtCet,
        UserId,
        DisplayName = '',
        Token = '',
        IsDefault = false,
        CardholderName = '',
        Expiration: {
          Month = 1,
          Year = 2020
        },
        Type,
        Status,
        CardType
      } = creditCardData;

      mappedData = {
        Id: <DisplayGuid>{Id}</DisplayGuid>,
        'Created At (CET)': <DisplayDate>{CreatedAtCet}</DisplayDate>,
        Status: <DisplayStatus mapping={paymentMethodStatus}>{Status}</DisplayStatus>,
        'User Id': <DisplayGuid baseAnchor='/user'>{UserId}</DisplayGuid>,
        DisplayName,
        Token,
        Type: <DisplayType mapping={paymentMethodType}>{Type}</DisplayType>,
        IsDefault: <DisplayBoolean>{IsDefault}</DisplayBoolean>,
        CardholderName,
        'Card Number': <DisplayPaymentMethod>{creditCardData}</DisplayPaymentMethod>,
        'Exp Month': Month,
        'Exp Year': Year,
        CardType
      };
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={errorMessage} />

            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='Credit card details'
                documentDescription='Credit card details'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                Credit Card
              </h2>
              <h5 className='main-page-subheader'>{creditCardId}</h5>
              <br />

              {
                mappedData ? (
                  <React.Fragment>
                    <DataDefinitionList
                      listData={mappedData}
                      classNames={['detail-page-list']}
                    />
                  </React.Fragment>
                ) : <Loader hasLoaded={false}>Loading...</Loader>
              }
            </div>

            <DetailsRightBar>
              <Divider>Links</Divider>
              <NoLink>None</NoLink>
              <Divider>Actions</Divider>
              <NoLink>None</NoLink>
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const CreditCard = withRouter(withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(CreditCardInternal)));

CreditCard.requiresLogin = true;
CreditCard.propTypes = { isLoggedIn: PropTypes.bool };

export default CreditCard;
